import {
  get
} from "../utils";

export default host => voiceId => get(`${host}/voices/${voiceId}?include=audio:url`)
  .then(response => response.json())
  .then(json => json.data)
  .then(data => data.audio.url)